module.exports = __webpack_public_path__ + "img/Youtube-Large.4c1ed4ed.svg";